import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router';

export const JobDetails = () => {

    const history = useHistory()
    const [detailData, setDetaildata] = useState()
////// get jobcard data

  useEffect(() => {
    getDetails();
  },[])

  
  const getDetails = () => {
    const jobData = history.location.state
    setDetaildata(jobData)
  }

  console.log('detail========>', detailData)


    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12 my-4">
                                <h3 className="mb-3 d-flex align-items-center"><b>Booking ID - 000771/130421/US  </b> <img className="shareicon" src="/admin/assets/images/share_icon.svg" height="20" alt="not found" /></h3>
                                {/* <p className="text-muted mb-0">Advance paid - 0.00 AED</p> */}
                                <small className="text-muted"><b>Date - 
                                {
                                    detailData && detailData.schedule_pickup.map(val=>{
                                        return val.data
                                    })
                                }
                                 </b></small>
                            </div>
                            {/* <div className="col-md-12  d-flex align-items-center justify-content-center" >
                                <div id="trackingSec" className="trackingSec">
                                    <div className="overflow-auto">
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Booking Confirmed</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Ship at warehouse</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Departed</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Arrived</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Delivered</span>
                                        </div>

                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="d-flex places col-lg-6 col-12 mx-auto border align-items-center justify-content-between mb-4">
                                <div className="fromPlace">
                                    <span></span>
                                    <h5 className="mb-0"><small style={{ fontSize: '12px' }}>From</small><br />Indore</h5>
                                </div>
                                <div className="path flex-grow-1 text-center">
                                    <span>Courier Door to Door</span>
                                </div>
                                <div className="toPlace">
                                    <span></span>
                                    <h5 className="mb-0"><small style={{ fontSize: '12px' }}>To</small><br />Dubai</h5>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row mb-3">
                                        <div className="col-lg-4 col-md-4 mb-6">
                                            <div className="card p-3 h-100">
                                                <div className="text-center ">
                                                    <div className="iconImg mx-auto my-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                                                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                                        </svg>
                                                    </div>
                                                    <h5>{detailData && detailData.customer_info.customer_name}</h5>

                                                </div>
                                                <hr />
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td className="py-1">Customer Type - </td>
                                                            <td className="py-1">{detailData && detailData.customer_info.customer_type}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-1">Contact No - </td>
                                                            <td className="py-1">
                                                            {detailData && detailData.customer_info.customer_number}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-1">Email - </td>
                                                            <td className="py-1">
                                                                {detailData && detailData.customer_info.customer_email}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-1">Referral Code - </td>
                                                            <td className="py-1">7676</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="col-lg-8 col-md-8 mb-6">
                                            <div className="card p-3 h-100">
                                                <div className=" d-md-flex">
                                                    <div className="iconImg mx-auto my-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-truck" viewBox="0 0 16 16">
                                                            <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                        </svg>
                                                    </div>
                                                    <div className="flex-grow-1 my-3 ps-3 text-md-left">
                                                        <h5>Shipment Summary</h5>
                                                        <p className="mb-0">Shipment Type - {detailData && detailData.shipment_summary_and_cargo.shipment_type}</p>
                                                        <p className="mb-0">Quotation No. - 34466789</p>
                                                        <p className="mb-0">Service Type - {detailData && detailData.shipment_summary_and_cargo.service}</p>
                                                    </div>
                                                </div>
                                                <hr /><div className="row">
                                                    <div className="col-md-6 border-end">
                                                        <table width="100%">
                                                            <tbody>
                                                                <tr><td className="py-1">Shipping Mode - </td><td className="py-1">{detailData && detailData.shipment_summary_and_cargo.shipping_mode}</td></tr>
                                                                <tr><td className="py-1">Cargo Summary - </td><td className="py-1">{detailData && detailData.shipment_summary_and_cargo.cargo_summery}</td></tr>
                                                                <tr><td className="py-1">Payment Status - </td><td className="py-1">Pending</td></tr>
                                                                <tr><td className="py-1">Destination -</td><td className="py-1">{detailData && detailData.shipment_summary_and_cargo.destination}</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <table width="100%">
                                                            <tbody>
                                                                <tr><td className="py-1">Origin - </td><td className="py-1">{detailData && detailData.shipment_summary_and_cargo.origin}</td></tr>
                                                                <tr><td className="py-1">Customer Service Incharge - </td><td className="py-1">{detailData && detailData.shipment_summary_and_cargo.customer_service_incharge}</td></tr>
                                                                <tr><td className="py-1">Sales Person Name - </td><td className="py-1">{
                                                                    detailData && detailData.shipment_summary_and_cargo.sales_person_name
                                                                }</td></tr>
                                                                <tr><td className="py-1">Payment Status - </td><td className="py-1"><span className="badge bg-warning">Awaiting Receipt</span></td></tr>
                                                                <tr><td className="py-1">Value of Goods - </td><td className="py-1">
                                                                {
                                                                    detailData && detailData.shipment_summary_and_cargo.value_of_goods
                                                                }
                                                                </td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div></div>
                                        </div>
                                        {/* <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card p-3 h-100">
                                                <div className="text-center">
                                                    <div className="iconImg mx-auto my-3">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-shop" viewBox="0 0 16 16">
                                                            <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z" />
                                                        </svg>
                                                    </div>
                                                    <h5>Retailer Name</h5>
                                                    <p className="mb-0">Service - Door To Door</p>
                                                    <p className="mb-0">Quotation No - 989569898</p>
                                                </div>

                                                <hr />
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td className="py-1">Job Id - </td>
                                                            <td className="py-1">000771/130421/US</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-1">Type - </td>
                                                            <td className="py-1">Air</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-1">Service - </td>
                                                            <td className="py-1">Door to Door</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="py-1"> Quotation No. - </td>
                                                            <td className="py-1">123456</td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card p-3">
                                        <div className="row">
                                            <ul className="nav mb-3 mt-0 tablist profiletab" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link active" id="pills-instructions-tab" data-bs-toggle="pill" data-bs-target="#pillsinstructions" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/document.svg" alt="not found" /><span className="showondesk">Sender / Receiver</span></a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-cargodtls-tab" data-bs-toggle="pill" data-bs-target="#pillscargodtls" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/package.svg" alt="not found" /><span className="showondesk">Carrier Details</span></a>
                                                </li>

                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillsaddons" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" alt="not found" /><span className="showondesk">Add Ons</span></a>
                                                </li>

                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillscargo" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" alt="not found" /><span className="showondesk">Cargo Details</span></a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillrevenue" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" /><span className="showondesk">Revenue / Cost</span></a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillsdocumentation" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" alt="not found" /><span className="showondesk">Documents</span></a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillspayment" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" alt="not found" /><span className="showondesk">Payment Details</span></a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillstracking" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" alt="not found" /><span className="showondesk">Tracking</span></a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillscomments" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" alt="not found" /><span className="showondesk">Comments</span></a>
                                                </li>

                                            </ul>
                                        </div>
                                        <div className="tab-content " id="pills-tabContent">
                                            <div className="tab-pane fade show active" id="pillsinstructions" role="tabpanel">
                                                <div className="col-12">
                                                    <div className="d-flex flex-wrap align-items-center">
                                                        <h5 className="my-4 fw-bold flex-grow-1">Sender / Receiver Contact</h5>
                                                        {/* <button className="btn btn-success">Add/Pickup Request</button> */}
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr className="lh-sm">
                                                                    <th> Pick Up Contact No.</th>
                                                                    <th>Pick Up Name</th>
                                                                    <th>Pick Up Address:</th>
                                                                    <th>Receiver Contact No:</th>
                                                                    <th>Receiver Name</th>
                                                                    <th>Delivery Address</th>
                                                                    {/* <th>Status</th>
                                                                    <th>Attachment</th>
                                                                    <th>Action</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        97198683095532
                                                                    </td>
                                                                    <td>Lorem Ipsum</td>
                                                                    <td>55- IIM Collges road , rau, Indore</td>
                                                                    <td>{detailData && detailData.receiver_info.receiver_number}</td>
                                                                    <td>{detailData && detailData.receiver_info.receiver_name}</td>
                                                                    <td>55- IIM Collges road , rau, Indore</td>

                                                                </tr>
                                                               
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillscargodtls" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Carrier Details</h5>
                                                <div className="col-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr className="lh-sm">
                                                                    <th>M Awb /M B/L </th>
                                                                    <th>H Awb / H B/L</th>
                                                                    <th>Carrier Name</th>
                                                                    <th>Shipment Type</th>
                                                                    <th>Port of Entry</th>
                                                                    {/* <th>Total Weight</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                            {
                                                                detailData && detailData.carrier_details.map((item, key)=>{
                                                                    return(
                                                                <tr key={key}>
                                                                    <td>{item.m_awb_mb_l}</td>
                                                                    <td>{item.h_awb_mb_l}</td>
                                                                    <td>{item.carrier_name}</td>
                                                                    <td>{item.shipment_type}</td>
                                                                    <td>{item.port_of_entry}</td>
                                                                </tr>
                                                                    )
                                                                })
                                                            }
                                                               
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="tab-pane fade" id="pillsaddons" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Add Ons</h5>
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Packing</th>
                                                                <th>Insurance</th>
                                                                <th>Storage</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{detailData && detailData.add_ons.packing}</td>
                                                                <td>{detailData && detailData.add_ons.insurance}</td>
                                                                <td>{detailData && detailData.add_ons.storage}</td>
                                                            </tr>
                                                            
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillscargo" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Cargo Details ( Booking / Actuals)</h5>
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Package 1 - Weight / L x W x H</th>
                                                                <th>Package 2 - Weight / L x W x H</th>
                                                                <th>Total Cargo </th>
                                                                <th>Cargo Description H</th>
                                                                <th>Retailer1 Name / Value of Goods</th>
                                                                <th>Retailer2 Name / Value of Goods</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                        {
                                                                detailData && detailData.cargo_details.map((item, key)=>{
                                                                    return(
                                                                <tr key={key}>
                                                                    <td>65656</td>
                                                                    <td>34687</td>
                                                                    <td>{item.total_carge}</td>
                                                                    <td>{item.cargo_description} </td>
                                                                    <td>{item.rataliar}, {item.value_of_goods}</td>
                                                                    <td>{item.rataliar}, {item.value_of_goods}</td>
                                                                </tr>
                                                                    )
                                                                })
                                                            }

                                                            
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillrevenue" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Revenue/Cost</h5>
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Invoice Amt 1</th>
                                                                <th>Invoice Amt 2</th>
                                                                <th>Invoice Amt 3</th>
                                                                <th>Cost of Vendors</th>
                                                                <th>Vendor 1</th>
                                                                <th>Vendor 2</th>
                                                                <th>Vendor 3</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                            <tr>
                                                                <td>#65656</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>
                                                                <td>56565</td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillsdocumentation" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Documentation</h5>
                                                <div className="col-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr className="lh-sm">
                                                                    <th>Customer Docs 1 </th>
                                                                    <th>Customer Docs 2</th>
                                                                    <th>Shipment Docs</th>
                                                                    <th>Doc 1</th>
                                                                    <th>Doc 2 </th>
                                                                    {/* <th>Total Weight</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillspayment" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Payment Details</h5>
                                                <div className="col-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr className="lh-sm">
                                                                    <th>Order Summary </th>
                                                                    <th>Invoice 1</th>
                                                                    <th>Invoice 2</th>

                                                                    {/* <th>Total Weight</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>xyz</td>
                                                                    <td>xyz</td>

                                                                </tr>
                                                                <tr>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>xyz</td>
                                                                    <td>xyz</td>

                                                                </tr>
                                                                <tr>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>xyz</td>
                                                                    <td>xyz</td>

                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillstracking" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Tracking Status </h5>
                                                <div className="col-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr className="lh-sm">
                                                                    <th>Each Tracking Status with Date </th>

                                                                    {/* <th>Total Weight</th> */}
                                                                </tr>
                                                            </thead>
                                                            {/* <tbody>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                            </tbody> */}
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillscomments" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Comments </h5>
                                                <div className="col-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr className="lh-sm">
                                                                    <th>All comments from all depts related to the job </th>
                                                                    {/* <th>Total Weight</th> */}
                                                                </tr>
                                                            </thead>
                                                            {/* <tbody>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>152</td>
                                                                    <td>256.00 Kg</td>
                                                                    <td>50 x 100 x 50</td>
                                                                    <td>lorem ipsum dolor sit amet</td>
                                                                    <td>0.052 M<sup>3</sup></td>
                                                                    <td>256.00 Kg</td>
                                                                </tr>
                                                            </tbody> */}
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pillscomment" role="tabpanel">
                                                <h5 className="my-4 fw-bold">Comments</h5>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam et gravida velit. Nulla leo orci, aliquet a lobortis vel, tempus eu nunc. Nulla mattis dolor nec leo fringilla convallis. Praesent et semper dolor. Quisque ipsum purus, dignissim in elementum vitae, eleifend ut felis. Nunc vitae efficitur lorem. In vulputate urna eu purus pellentesque, a condimentum purus sollicitudin. Proin et arcu tortor. Phasellus nec commodo arcu. Nulla non pellentesque libero, vel hendrerit nibh. Curabitur purus purus, tempor eget mattis vitae, volutpat at ligula. Aliquam malesuada dignissim rutrum. Sed libero diam, interdum ut est sed, porttitor posuere velit. Fusce eu quam vel velit rhoncus bibendum.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-4">
                                    <div className="card p-3">

                                        <h5 className="mt-0">Order Summary</h5>
                                        <div className="mt-3">
                                            <table width="100%" style={{ minWidth: '100%' }} className="table table-bordered lh-sm">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="3" className="gray-bold">
                                                            COURIER / Door To DOOR <br />
                                                            India - United States
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;</td>
                                                        <td className="text-right"><strong>Booked</strong></td>
                                                        <td className="text-right"><strong>Actual</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Freight
                                                        </td>
                                                        <td className="text-right">
                                                            AED 35,810.00
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3" className="text-right smaller">
                                                            (Transit 10 days)
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="service">
                                            <h5 className="color-green">Add-ons</h5>
                                            <table width="100%" style={{ minWidth: '100%' }} className="table table-striped">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            Package
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Insurance Premium
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Storage (0 Days)<br />
                                                            <small>(Free upto 7 days)</small>
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                        <td className="text-right">
                                                            AED 0.00
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="service">
                                            <h5 className="color-green">Taxes</h5>
                                            <table width="100%" style={{ minWidth: '100%' }} className="table table-bordered lh-sm">
                                                <tbody>
                                                    <tr>
                                                        <td>Sub Total:</td>
                                                        <td >AED 35,810.00</td>
                                                        <td >AED 0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Discount:</td>
                                                        <td >AED 0.00</td>
                                                        <td >AED 0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Net:</td>
                                                        <td >AED 35,810.00</td>
                                                        <td >AED 0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>VAT:</td>
                                                        <td >AED 0.00</td>
                                                        <td >AED 0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gross:</td>
                                                        <td>AED 35,810.00</td>
                                                        <td>AED 0.00</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}